import React from 'react';
import { View, Text } from 'react-native';

import { VerticalDivider } from '../widgets/Common-Widget';

import AppTheme from '../../AppTheme';
import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import Colors from '../constants/AppColors';

const ConfirmationPopup = (props) => {
    const showPopup = props.showPopup
    const modalData = props.modalData
    const closeModal = props.closeModal
    const primaryAction = props.primaryAction
    const secondaryAction = props?.secondaryAction
    const hasBackdrop = props?.hasBackdrop ?? true
    return (<Modal key={modalData.title} isVisible={showPopup}
        deviceHeight={AppTheme.modalHeight} hasBackdrop={hasBackdrop}
        onBackdropPress={() => closeModal()} backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOut={"slideOutDown"} animationOutTiming={AppTheme.modalAnimationDuration}>
        <View style={[AppStyles.modalContainer, { borderRadius: 12, padding: 0 }]}>
            <View style={{ padding: 16 }}>
                <Text style={[TextStyle.text14b]}>{modalData.title}</Text>
                <Text style={[TextStyle.text12, { color: Colors.grey.text, paddingTop: 12 }]}>
                    {modalData.subTitle}</Text>
            </View>
            <View style={[AppStyles.flexRowSpaceEvenly, AppStyles.bottomBorderView,
            { backgroundColor: Colors.blue.bg, borderTopWidth: 1, borderColor: Colors.grey.border }]}>
                <Text onPress={() => { closeModal(); secondaryAction ? secondaryAction() : null }}
                    style={[TextStyle.text14b, {
                        color: Colors.primary, textAlign: 'center', width: 150
                    }]}>{modalData.secondaryCTATitle}</Text>
                <VerticalDivider height={40} />
                <Text onPress={() => { closeModal(); primaryAction() }}
                    style={[TextStyle.text14b, {
                        color: Colors.primary, textAlign: 'center', width: 150
                    }]}>{modalData.primaryCTATitle}</Text>
            </View>
        </View>
    </Modal>
    )
}

export default ConfirmationPopup